import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { API_BASE } from "../config/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAdminLogin = async () => {
    if (!email || !password) {
      return alert("Email & Password required");
    }

    try {
      setLoading(true);

      const res = await fetch(`${API_BASE}/api/auth/login`, {
        method: "POST",
        credentials: "include", // ✅ VERY IMPORTANT (cookie allow)
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setLoading(false);
        return alert(data.message || "Login failed");
      }

      if (data.user.role !== "admin") {
        setLoading(false);
        return alert("You are not an admin");
      }

      // context me sirf user info (token nahi)
      login(data.user);
      navigate("/admin");
    } catch {
      alert("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2
      bg-gradient-to-br from-black via-gray-950 to-black text-white">

      {/* LEFT INFO PANEL */}
      <div className="hidden lg:flex flex-col justify-center px-20
        relative overflow-hidden
        bg-gradient-to-br from-slate-950 via-gray-900 to-slate-900">

        <div className="absolute inset-0
          bg-[radial-gradient(circle_at_top,rgba(34,197,94,0.15),transparent_60%)]" />

        <div className="relative z-10 max-w-lg">
          <div className="mb-6 inline-flex items-center gap-2
            bg-black/50 border border-emerald-500/30
            px-4 py-1.5 rounded-full text-sm font-semibold text-emerald-400">
            🛡 Secure Admin Zone
          </div>

          <h1 className="text-5xl font-extrabold mb-6 leading-tight">
            Administrator Console
          </h1>

          <p className="text-lg text-gray-300 mb-8">
            Restricted access to system administrators only.
          </p>

          <div className="space-y-4 text-sm text-gray-300">
            <div className="bg-black/40 rounded-xl p-4 border border-gray-800">
              🔐 Unauthorized access attempts are monitored
            </div>
            <div className="bg-black/40 rounded-xl p-4 border border-gray-800">
              📜 All admin actions are logged
            </div>
            <div className="bg-black/40 rounded-xl p-4 border border-gray-800">
              🧠 Advanced privileges enabled
            </div>
          </div>

          <p className="mt-10 text-xs text-gray-400 italic">
            If you are not an administrator, please exit this page.
          </p>
        </div>
      </div>

      {/* RIGHT LOGIN PANEL */}
      <div className="flex items-center justify-center px-6">
        <div className="bg-gray-900/80 backdrop-blur
          p-8 rounded-2xl w-full max-w-md
          border border-emerald-500/30 shadow-2xl">

          <h2 className="text-2xl font-bold mb-1 text-center">
            🔐 Admin Login
          </h2>
          <p className="text-sm text-gray-400 mb-6 text-center">
            Authorized access only
          </p>

          <input
            type="email"
            placeholder="Admin Email"
            className="w-full p-3 mb-4 bg-gray-800 rounded-lg outline-none
            focus:ring-2 focus:ring-emerald-500"
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            type="password"
            placeholder="Password"
            className="w-full p-3 mb-6 bg-gray-800 rounded-lg outline-none
            focus:ring-2 focus:ring-emerald-500"
            onChange={(e) => setPassword(e.target.value)}
          />

          <button
            disabled={loading}
            onClick={handleAdminLogin}
            className={`w-full py-3 rounded-lg font-semibold transition
            ${loading
              ? "bg-gray-600 cursor-not-allowed"
              : "bg-emerald-600 hover:bg-emerald-700"}`}
          >
            {loading ? "Authenticating..." : "Access Admin Console"}
          </button>

          <p className="text-sm text-gray-400 mt-4 text-center">
            Not an admin?{" "}
            <Link to="/login" className="text-indigo-400 hover:underline">
              Go to User Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
